import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';

import MainPage from './MainPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [<RoutePrivate exact={true} key="main" path="/" component={MainPage} {...{ isLoggedIn }} />];
}



// WEBPACK FOOTER //
// ./src/components/main/Main.Routes.tsx